// src/views/components/Motion/Magnetic.jsx
import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useReducedMotion } from 'framer-motion';

const Magnetic = ({ children, strength = 0.3, className = '', style = {} }) => {
  const ref = useRef(null);
  const shouldReduceMotion = useReducedMotion();

  const rawX = useMotionValue(0);
  const rawY = useMotionValue(0);

  const x = useSpring(rawX, { stiffness: 250, damping: 15, mass: 0.5 });
  const y = useSpring(rawY, { stiffness: 250, damping: 15, mass: 0.5 });

  const handleMouseMove = (e) => {
    if (!ref.current || shouldReduceMotion) return;
    const { clientX, clientY } = e;
    const { left, top, width, height } = ref.current.getBoundingClientRect();

    const middleX = clientX - (left + width / 2);
    const middleY = clientY - (top + height / 2);

    rawX.set(middleX * strength);
    rawY.set(middleY * strength);
  };

  const handleMouseLeave = () => {
    rawX.set(0);
    rawY.set(0);
  };

  if (shouldReduceMotion) {
    return <div className={className} style={style}>{children}</div>;
  }

  return (
    <motion.div
      ref={ref}
      className={`magnetic-wrapper ${className}`}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ display: 'inline-block', x, y, ...style }}
    >
      {children}
    </motion.div>
  );
};

export default Magnetic;
